export default class ConsentManagement {
  constructor() {
    this.gdpr = {};
    this.usp = {};
  }

  setGdpr(hasConsent, timeout) {
    this.gdpr = hasConsent
      ? {
          cmpApi: 'iab',
          timeout,
          defaultGdprScope: true,
        }
      : null;
    return this;
  }

  setUsp(timeout) {
    this.usp = {
      cmpApi: 'iab',
      timeout,
    };
    return this;
  }

  build() {
    return {
      usp: this.usp,
      gdpr: this.gdpr,
    };
  }
}
